export default __webpack_public_path__ + "static/media/interface-2.ad84047c.png";